import "core-js/modules/es.array.push.js";
import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-18777a4f"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "main"
};
const _hoisted_2 = {
  class: "title"
};
const _hoisted_3 = {
  class: "pain"
};
const _hoisted_4 = {
  class: "solution"
};
const _hoisted_5 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "ws_title"
}, "解决方案", -1));
const _hoisted_6 = {
  class: "desc"
};
const _hoisted_7 = ["src"];
const _hoisted_8 = {
  class: "app"
};
const _hoisted_9 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "ws_title"
}, "应用场景", -1));
const _hoisted_10 = {
  key: 0,
  class: "app-box box-1"
};
const _hoisted_11 = ["src"];
const _hoisted_12 = {
  class: "info"
};
const _hoisted_13 = {
  class: "title"
};
const _hoisted_14 = ["src"];
const _hoisted_15 = {
  class: "info"
};
const _hoisted_16 = {
  class: "title"
};
import { ref } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import { Navigation, Autoplay } from 'swiper';
import solutionData from '@/data/solution';
import productData from '@/views/device-detail/data/product';
export default /*#__PURE__*/_defineComponent({
  __name: 'solution',
  setup(__props) {
    const modules = [Navigation, Autoplay];
    const $route = useRoute();
    const router = useRouter();
    const id = $route.params.id;
    const currentData = ref({});
    const keys = Object.keys(solutionData);
    // 防止id被篡改导致页面数据出错
    if (!keys.includes(id)) {
      router.replace('/solution');
    }
    currentData.value = solutionData[id];
    // 目前所有的解决方案的产品都是单模网关、多模网关、U高速天基物联网模组
    const productList = productData;
    const productIds = [0, 1, 2];
    const expertList = productIds.map(id => {
      return {
        ...productList[id],
        id
      };
    });
    const toDevice = id => {
      router.push(`/device-detail/${id}`);
    };
    const swiper = ref(null);
    const onSwiper = currentSwiper => {
      swiper.value = currentSwiper;
    };
    const toSwiper = isNext => {
      isNext ? swiper.value.slideNext() : swiper.value.slidePrev();
    };
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock(_Fragment, null, [_createElementVNode("div", {
        class: "header",
        style: _normalizeStyle({
          'background-image': `url(${currentData.value.bannerImg})`
        })
      }, [_createElementVNode("div", _hoisted_1, [_createElementVNode("h3", _hoisted_2, _toDisplayString(currentData.value.title) + "解决方案", 1), _createElementVNode("p", _hoisted_3, _toDisplayString(currentData.value.pain), 1)])], 4), _createElementVNode("div", _hoisted_4, [_hoisted_5, _createElementVNode("p", _hoisted_6, _toDisplayString(currentData.value.solution), 1), _createElementVNode("img", {
        src: currentData.value.solutionImg,
        alt: "",
        class: "main-img"
      }, null, 8, _hoisted_7)]), _createElementVNode("div", _hoisted_8, [_hoisted_9, currentData.value.application.length === 1 ? (_openBlock(), _createElementBlock("div", _hoisted_10, [_createElementVNode("img", {
        src: currentData.value.application[0].img,
        alt: "",
        class: "img"
      }, null, 8, _hoisted_11), _createElementVNode("div", _hoisted_12, [_createElementVNode("p", _hoisted_13, _toDisplayString(currentData.value.application[0].title), 1), _createElementVNode("p", null, _toDisplayString(currentData.value.application[0].desc), 1)])])) : _createCommentVNode("", true), currentData.value.application.length !== 1 ? (_openBlock(), _createElementBlock("div", {
        key: 1,
        class: _normalizeClass(["app-box box-more", 'box-' + currentData.value.application.length])
      }, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(currentData.value.application, (item, index) => {
        return _openBlock(), _createElementBlock("div", {
          class: "content",
          key: index
        }, [_createElementVNode("img", {
          src: item.img,
          alt: "",
          class: "img"
        }, null, 8, _hoisted_14), _createElementVNode("div", _hoisted_15, [_createElementVNode("p", _hoisted_16, _toDisplayString(item.title), 1), _createElementVNode("p", null, _toDisplayString(item.desc), 1)])]);
      }), 128))], 2)) : _createCommentVNode("", true)])], 64);
    };
  }
});